

// actions types

export const GetHeaderTheme = 'GetHeaderThemes';
export const GetHeaderThemeLoaded = 'GetHeaderThemeLoaded';
export const toggle_map = 'toggle_map';
export const update_auth_modal_display_status = 'update_auth_modal_display_status';
export const SIGN_OUT = "SIGN_OUT";
export const update_cart_display_status = "update_cart_display_status";
export const set_active_location = "set_active_location";
export const show_header_cart = "show_header_cart";
export const SET_REDIRECT = "SET_REDIRECT";
export const SIGN_IN = "SIGN_IN";
export const set_voucher_percentage = "set_voucher_percentage";
export const SET_ACTIVE_USER_ADDRESS = 'SET_ACTIVE_USER_ADDRESS';
export const GET_TAX_AND_DELIEVERY = "GET_TAX_AND_DELIEVERY";
export const set_voucher = "set_voucher";
export const recalculate_cart_total = "recalculate_cart_total";
export const CHECK_VOUCHER = "CHECK_VOUCHER";
export const set_cart_total_with_voucher = "set_cart_total_with_voucher";
export const GET_CATEGORIES = "GET_CATEGORIES";
export const CATEGORIES_LOADED = "CATEGORIES_LOADED";
export const GET_HEADER_CATEGORIES = "GET_HEADER_CATEGORIES";
export const CATEGORIES_HEADER_LOADED = "CATEGORIES_HEADER_LOADED";
export const remove_from_cart = "remove_from_cart";
export const update_auth_modal_status = "update_auth_modal_status";
export const GET_SITE_THEME = "GET_SITE_THEME";
export const SITE_THEME_LOADED = "SITE_THEME_LOADED";

export const show_branches_modal = "show_branches_modal";
export const request_vendor_branches = "request_vendor_branches";
export const set_vendor_branches = "set_vendor_branches";
export const set_active_branch = "set_active_branch";
export const set_auth_modal_type = "set_auth_modal_type";
export const update_mobile_search_bar_display = "update_mobile_search_bar_display";
export const mobile_searching = "mobile_searching";
export const set_mobile_search_results = "set_mobile_search_results";
